import { apiAdd, apiDelete, apiGet, apiUpdate } from "../../../API/Service/apiClient";

export const handleGet_data = async (  
  {setListLoading,setBanners,setFiles}
  ) => {
    setListLoading(true);
  let data={limit:100,page:1};
  try {
    const resData = await apiGet("banners", data);         
    setBanners(resData?.data)    
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setListLoading(false);
    setFiles(null);
  }
};

export const handleSubmit_data = async (  
  {setLoading,data,showToast,
    setListLoading,setBanners,setFiles,setPreview,setLink}
  ) => {
  setLoading(true);
  let formData=new FormData();
  formData.append("redirect_path", data?.redirect_path);
  if (data?.hasOwnProperty('imgpath')) {
    formData.append("imgpath", data?.imgpath); 
  }
  if(data?.id > 0){formData.append("id", data?.id); }
  try {
    let resData={};
    resData = await apiAdd("banners", formData,{
      contentType: "multipart/form-data"
    });
             
    if(resData?.data?.id > 0){
      handleGet_data({setListLoading,setBanners,setFiles})      
      showToast("Banner saved successfully","success")
      setFiles(null)      
      setPreview(null);
      setLink("");
    }else{
      showToast("Something went wrong! Please try again","danger")
    }    
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);    
  }
};

export const handleSubmitUpdate_data = async (  
  {setLoading,data,showToast,
    setListLoading,setBanners,setFiles,setPreview,setLink}
  ) => {
  setLoading(true);
  let formData=new FormData();
  formData.append("redirect_path", data?.redirect_path);  
  if(data?.id > 0){formData.append("id", data?.id); }
  try {
    let resData={};
    resData = await apiUpdate("banners", formData,{
      contentType: "multipart/form-data"
    });
             
    if(resData?.data?.id > 0){
      handleGet_data({setListLoading,setBanners,setFiles})      
      showToast("Banner saved successfully","success")
      setFiles(null)      
      setPreview(null);
      setLink("");
    }else{
      showToast("Something went wrong! Please try again","danger")
    }    
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);    
  }
};

export const handleDelete_data = async (  
  {item,showToast,setBanners,setActionLoader}
  ) => {
      
  try {
    setActionLoader({deleteId:item?.id})
    const resData = await apiDelete("banners", item);
    if(resData?.data > 0){
      showToast("Deleted successfully", "success");
      setBanners(prev => prev.filter(el => el.id !== item?.id));
    }else{
      showToast("Something went wrong! Please try again", "danger");  
    }         
    
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setActionLoader({})
  }
};